export default "__VITE_ASSET__2f708998__"